/* eslint-disable import/prefer-default-export */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import TextField from '../textfield/textfield.component';
import TextAreaField from '../textfield/textareafield.component';
import NumberField from '../numberfield/numberfield.component';
import RadioSet from '../radioset/radioset.component';
import InputStepper from '../inputstepper/inputstepper.component';
import RValueField from '../rvaluefield/rvaluefield.component';
import AreaField from '../areafield/areafield.component';
import SelectField from '../select/select.component';
import PercentRValueField from '../rvaluefield/percentrvaluefield.component';
import RadioRValueField from '../rvaluefield/radiorvaluefield.component';
import applyLogic from '../util/applyLogic';

const ConditionalField = ({ show, children }) => {
    return show ? children : null;
};

const AlertIcon = () => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='16' height='18' viewBox='0 0 16 18' fill='none'>
            <path fillRule='evenodd' clipRule='evenodd' d='M15.715 13.3426C14.4162 11.9833 14.1264 9.97446 13.8567 8.02554C13.447 5.14714 12.9874 1.89894 8.90102 1.47918V0.949472C8.90102 0.429761 8.48138 0 7.95185 0C7.42231 0 7.00268 0.429761 7.00268 0.949472V1.46918C2.94623 1.89894 2.49662 5.13715 2.08698 8.01555C1.81722 9.96446 1.52747 11.9733 0.238602 13.3326C-0.00118847 13.6124 -0.0711272 14.0222 0.0787415 14.372C0.22861 14.7218 0.568313 14.9517 0.94798 14.9517H4.90451C4.9245 16.6408 6.2933 17.99 7.97183 18C9.65036 18 11.0092 16.6408 11.0391 14.9517H15.0556C15.4353 14.9517 15.775 14.7218 15.9249 14.372C16.0747 14.0222 15.9948 13.6124 15.735 13.3426H15.715ZM7.96184 16.0911C7.3224 16.0911 6.80285 15.5813 6.78287 14.9417H9.13081C9.11083 15.5813 8.59129 16.0911 7.95185 16.0911H7.96184ZM7.96184 13.0428H2.74641C3.51573 11.5336 3.75552 9.83454 3.97533 8.2854C4.44492 4.93726 4.8046 3.31816 7.96184 3.31816C11.1191 3.31816 11.5187 4.92726 11.9883 8.2854C12.2081 9.83454 12.4479 11.5436 13.2172 13.0428H7.96184Z' fill='white'/>
        </svg>
    );
};
@observer
export class FormField extends Component {
    getTextField(field) {
        return (
            <TextField
                errors={field.errors}
                {...field.bind()}
                {...field.get('extra')}
            />
        );
    }

    getTextAreaField(field) {
        return (
            <TextAreaField
                errors={field.errors}
                {...field.bind()}
                {...field.get('extra')}
            />
        );
    }

    getNumberField(field) {
        return (
            <NumberField
                errors={field.errors}
                {...field.bind()}
                {...field.get('extra')}
            />
        );
    }

    getSelect(field) {
        return (
            <SelectField
                errors={field.errors}
                {...field.bind()}
                {...field.get('extra')}
            />
        );
    }

    getHiddenField(field) {
        return (
            <input
                type='hidden'
                {...field.bind()}
                {...field.get('extra')}
            />
        );
    }

    getContent(field) {
        return (
            <div className='ht-field ht-contentfield'>
                {field.label && <div className='bx--label'>{field.label}</div>}
                <div className='bx--form__helper-text'>
                    {field.extra.description()}
                </div>
            </div>
        );
    }

    getMessage(field) {
        if (!field.label || !field.extra.message) {
            return <></>;
        }
        return (
            <div className='ht-field ht-messagefield'>
                <div className='ht-messagefield__icon'>
                    <AlertIcon />
                </div>
                <div className='ht-messagefield__content'>
                    <h3 className='ht-messagefield__heading'>{field.label}</h3>
                    <div className='ht-messagefield__text' dangerouslySetInnerHTML={{ __html: field.extra.message }} />
                </div>
            </div>
        );
    }

    getRadioset(field) {
        return (
            <RadioSet
                errors={field.errors}
                extra = {field.extra}
                {...field.get('extra')} // moves anything inside extra to the RadioSet props
                {...field.bind()}
            />
        );
    }

    getStepper(field) {
        return <InputStepper {...field.bind()} {...field.get('extra')} />;
    }

    getAreaField(field) {
        return (
            <AreaField
                field={field}
                errors={field.errors}
                {...field.bind()}
                {...field.get('extra')}
            />
        );
    }

    getFieldset(field, formValues) {
        const { type, label } = field,
            showIf = field.extra ? field.extra.showIf : true,
            show = applyLogic(showIf, formValues);

        return (
            <ConditionalField key={field.name} show={show}>
                <fieldset data-name={field.name} data-path={field.path}>
                    <div className={`ht-${type}`}>
                        <div className={`ht-${type}-legend`}>
                            <legend>{label}</legend>
                        </div>
                        <div className={`ht-${type}-fields`}>
                            {field.extra && field.extra.description && (
                                <div className={`ht-${type}-description`}>
                                    {field.extra.description()}
                                </div>
                            )}
                            {field.map(currentField => {
                                currentField.errors =
                                    field.errors[currentField.name];

                                const showIf = currentField.extra ? currentField.extra.showIf : true,
                                    show = applyLogic(
                                        showIf,
                                        formValues
                                    );

                                return (
                                    <ConditionalField
                                        key={currentField.name}
                                        show={show}
                                    >
                                        {this.getField(currentField, formValues)}
                                    </ConditionalField>
                                );
                            })}
                        </div>
                    </div>
                </fieldset>
            </ConditionalField>
        );
    }

    getFieldWrapper(field, formValues) {
        return (
            <>
                {field.map(currentField => {
                    currentField.errors = field.errors[currentField.name];

                    const showIf = currentField.extra ? currentField.extra.showIf : true,
                        show = applyLogic(
                            showIf,
                            formValues
                        );

                    return (
                        <ConditionalField key={currentField.name} show={show} data-name={field.name} data-path={field.path}>
                            {this.getField(currentField, formValues)}
                        </ConditionalField>
                    );
                })}
            </>
        );
    }

    getFieldGroup(field, formValues) {
        const showIf = field.extra ? field.extra.showIf : true,
            show = applyLogic(showIf, formValues);

        return (
            <ConditionalField key={field.name} show={show}>
                <div className={`ht-${field.type}`} data-name={field.name} data-path={field.path}>
                    {field.map(currentField => {
                        currentField.errors = field.errors[currentField.name];

                        const showIf = currentField.extra ? currentField.extra.showIf : true,
                            show = applyLogic(
                                showIf,
                                formValues
                            );

                        return (
                            <ConditionalField key={currentField.name} show={show}>
                                {this.getField(currentField, formValues)}
                            </ConditionalField>
                        );
                    })}
                </div>
            </ConditionalField>
        );
    }

    getRootCollection(field, formValues) {
        return (
            <div className={`ht-${field.type}`}>
                {field.map(currentField => {
                    currentField.errors = field.errors[currentField.name];

                    const showIf = currentField.extra ? currentField.extra.showIf : true,
                        show = applyLogic(
                            showIf,
                            formValues
                        );

                    return (
                        <ConditionalField key={currentField.name} show={show}>
                            {this.getField(currentField, formValues)}
                        </ConditionalField>
                    );
                })}
            </div>
        );
    }

    getRValueField(field) {
        return (
            <RValueField
                field={field}
                errors={field.errors}
                {...field.get('extra')} // moves anything inside extra to the RValueField props
                {...field.bind()}
            />
        );
    }

    getPercentRValueField(field) {
        let numberField;
        let rvalueField;

        field.map(currentField => {
            currentField.errors = field.errors[currentField.name];
            if (currentField.type === 'numberfield') {
                numberField = currentField;
            } else if (currentField.type === 'rvaluefield') {
                rvalueField = currentField;
            }
            return true;
        });

        return (
            <PercentRValueField
                extra = {field.extra}
                label = {numberField.label}
                numberField = {numberField}
                rvalueField = {rvalueField}
                {...field.get('extra')}
                {...field.bind()}
            />
        );
    }

    getRadioRValueField(field, formValues) {
        let radioField;
        const rvalueFields = [];

        field.map(currentField => {
            currentField.errors = field.errors[currentField.name];

            if (currentField.type === 'radio') {
                radioField = currentField;
            } else if (currentField.type === 'rvaluefield') {
                rvalueFields.push(currentField);
            }

            return true;
        });

        return (
            <RadioRValueField
                formValues={formValues}
                {...field.bind()}
                extra = {field.extra}
                label={radioField.label}
                radioField={radioField}
                rvalueFields={rvalueFields}
            />
        );
    }

    getField(field, formValues) {
        if (typeof field.type === typeof undefined) return;

        switch (field.type) {
            case 'formsection': // top level fieldset
            case 'fieldset': // nested fieldset
                return this.getFieldset(field, formValues);
            case 'fieldgroup': // inline fields
            case 'collection': // collection of items
                return this.getFieldGroup(field, formValues);
            case 'rootcollection': // collection of items
                return this.getRootCollection(field, formValues);
            case 'fieldwrapper': // to aid in applyLogic
                return this.getFieldWrapper(field, formValues);
            case 'content':
                return this.getContent(field);
            case 'message':
                return this.getMessage(field);
            case 'hidden':
                return this.getHiddenField(field);
            case 'radio':
                return this.getRadioset(field);
            case 'numberfield':
                return this.getNumberField(field);
            case 'textfield':
                return this.getTextField(field);
            case 'textareafield':
                return this.getTextAreaField(field);
            case 'select':
                return this.getSelect(field);
            case 'stepper':
                return this.getStepper(field, formValues);
            case 'rvaluefield':
                return this.getRValueField(field);
            case 'percentrvaluefield':
                return this.getPercentRValueField(field);
            case 'radiorvaluefield':
                return this.getRadioRValueField(field, formValues);
            case 'areafield':
                return this.getAreaField(field);

            default:
                return <p>
                    {field.name} has new field type: {field.type}
                </p>;
        }
    }

    render() {
        const { field, formValues } = this.props;
        return this.getField(field, formValues);
    }
}
